export default __webpack_public_path__ + "images/fd82d5367484b6a1c25ee27b96ff4ca5-InviteAmigoPopUp.png";